import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLosses = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 37,
	height: 37,
	viewBox: "0 0 37 37",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.5 0C28.7173 0 37 8.28273 37 18.5C37 28.7173 28.7173 37 18.5 37C8.28273 37 0 28.7173 0 18.5C0 8.28273 8.28273 0 18.5 0ZM8 13.5166L16.1396 21.5879L20.54 17.2539L26.2598 22.833H23.4004V25H30V18.5H27.7998V21.3164L20.54 14.167L16.1396 18.5L9.54004 12L8 13.5166Z",
		fill: "{fill}"
	})
});
export default SvgLosses;
